import { Component, Injector, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AbstractComponent, CacheKeyEnum, Category, CategoryService, CategoryTypeEnum, ConfirmationComponent, Pager } from 'lib-trend-core';
import { Observable, Subject, debounceTime, distinctUntilChanged, switchMap, takeUntil } from 'rxjs';
import { CategoryAddComponent } from './category-add/category-add.component';

@Component({
    selector: 'category-component',
    // templateUrl: './category.component.html',
    templateUrl: './category.v2.component.html',
    styleUrl: './category.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CategoryComponent extends AbstractComponent implements OnInit {

  pager: Pager<Category> = new Pager<Category>({ perPage: 7 });
  listObservable: Observable<Pager<Category>>;

  private termoDaBusca: Subject<string> = new Subject<string>();

  typeCategory: CategoryTypeEnum = CategoryTypeEnum.RESPONSE;

  constructor(
    injector: Injector,
    public dialog: MatDialog,
    private categoryService: CategoryService,
  ) {
    super(injector);
    this.setupForm();
    this.loadingContent = true;
    this.cacheKey = CacheKeyEnum.CATEGORIES_LIST;
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    const cached = this.restoreState<Category>();
    if (!cached) {
      this.getList();
      return;
    }
    this.pager = cached.pager;
    this.searchString = cached.search ?? '';
    this.loadingContent = false;

    if (this.searchString) {
      this.formGroup.get('search').setValue(this.searchString);
    }
    this.setupObservableSearch();
  }

  private setupForm(): void {
    this.formGroup = this.formBuilder.group({
      search: [''],
    });
  }

  private setupObservableSearch(): void {
    this.listObservable = this.termoDaBusca.pipe(
      takeUntil(this.destroy$),
      debounceTime(500),
      distinctUntilChanged(),
      switchMap(term => {
        this.searchString = term;
        return this.categoryService.getAll(this.pager.page, this.pager.perPage, term, this.searchParams);
      })
    );
    this.listObservable.subscribe((pager: Pager<Category>) => {
      this.pager = pager;
      this.persistListState(this.pager, this.searchString, this.searchParams);
    });
  }

  search(termo: string) {
    this.pager.page = 1;
    this.termoDaBusca.next(termo);
  }

  loadPage(page: number) {
    this.pager.page = page;
    this.getList();
  }

  private getList() {
    this.loadingContent = true;
    this.searchParams = {
      company: super.getIDCurrentCompany(),
    };

    this.categoryService.getAll(this.pager.page, this.pager.perPage, this.searchString, this.searchParams)
      .pipe(takeUntil(this.destroy$)).subscribe({
        next: (pager: Pager<Category>) => {
          this.pager = pager;
          this.loadingContent = false;
          this.setupObservableSearch();
          this.persistListState(this.pager, this.searchString, this.searchParams);
        },
        error: () => this.loadingContent = false,
      });
  }

  add(): void {
    const dialogRef = this.dialog.open(CategoryAddComponent, {
      width: '600px',
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) this.getList();
    });
  }

  edit(item: Category): void {
    const dialogRef = this.dialog.open(CategoryAddComponent, {
      width: '600px',
      data: item
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) this.getList();
    });
  }

  // Dont delete if category is linked the a response fast
  delete(item: Category): void {
    const dialogRef = this.dialog.open(ConfirmationComponent, {
      width: '600px',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (Boolean(result) === true) {
        this.categoryService.delete(item._id).subscribe({
          next: () => {
            this.getList();
            this.alertService.success(this.t('category.list.deleteSuccess'));
          }
        });
      }
    });
  }
}
